import { useMemo } from 'react';

import { yachtDarkTheme } from '@/app/theme/yacht/dark-theme';
import { yachtLightTheme } from '@/app/theme/yacht/light-theme';
import { useUserTheme } from '@/entities/user';
import { AppTheme } from '@/shared/constants/app-theme.constant';

// TODO: Remove together with styled-components: this hook only feeds ThemeProvider.
// hdata-ui and Tailwind use `data-theme` on <html>, so ThemeHelmet should then set it from useUserTheme().
export const useCurrentTheme = () => {
	const theme = useUserTheme();

	// TODO: Remove the legacy Plant theme files .
	// Industrial intentionally uses the Yachting theme until the legacy theme is removed.
	return useMemo(() => (theme === AppTheme.Dark ? yachtDarkTheme : yachtLightTheme), [theme]);
};
